<app-data-grid-comp
    [columns]="columns"
    [filterCategories]="filterCategories"
    [gridDataResult]="gridDataResult"
    [pageSize]="pageSize"
    [skip]="skip"
    [tableId]="db_tables.TOIL"
    category="TOILRecords"
    [isLoading]="isLoading"
    [clearSelectedItems]="clearSelectedItems"
    [parentModelId]="employeeID"
    [targetEmployeeTablePermissions]="targetEmployeeTablePermissions"
    export="excel"
    [rowSelectionSettings]="{
        canSelectRows: true,
        selectableMode: 'multiple',
        selectRowBy: 'id'
    }"
    clickableRows="true"
    [sortable]="{
        mode: 'multiple'
    }"
    [sortableColumns]="sortableColumns"
    [accessAndHistoryURL]="accessAndHistoryURL"
    (emitPageChangeEvent)="pageChange($event)"
    (emitOpenDialogEvent)="openFormDialog($event)"
    (emitDeleteEvent)="deleteEmployeeToilRecords($event)"
    (emitFilterEvent)="filterCallback($event)"
    (emitSortEvent)="sortChange($event)"
></app-data-grid-comp>
